import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import AppsIcon from '@mui/icons-material/Apps';
import { productTypes } from '../../utils/enum/search-branches-enum';
import iconMobile from '../../assets/images/icon-mobile.png';
import iconTablet from '../../assets/images/icon-tablet.png';
import iconMiniAtm from '../../assets/images/icon-mini-atm.png';
import iconFresh from '../../assets/images/icon-fresh.png';
import iconElectric from '../../assets/images/icon-electric.png';
import { useMediaQuery } from 'react-responsive';
import { Responsive } from '../../utils/enum/responsive-enum';

interface Props {
  onComplete: (value: string[]) => void;
}

const iconMap: Record<string, string> = {
  โทรศัพท์มือถือ: iconMobile,
  แท็บเล็ต: iconTablet,
  ตู้เงินดี: iconMiniAtm,
  สินเชื่อหมุนเวียน: iconFresh,
  เครื่องใช้ไฟฟ้า: iconElectric,
};

export default function FilterProductType({ onComplete }: Props) {
  const [selected, setSelected] = useState<string[]>([]);
  const isTabletOrMobile = useMediaQuery({ query: `(max-width: ${Responsive.TABLE_OR_MOBILE})` });

  const handleSelect = (value: string) => {
    if (value === '0') {
      setSelected([]);
      onComplete([]);
      return;
    }
    const next = selected.includes(value) ? selected.filter((v) => v !== value) : [...selected, value];
    setSelected(next);
    onComplete(next);
  };

  const options = [
    { value: '0', label: 'ทั้งหมด' },
    ...productTypes.map((item) => ({ value: item.type, label: item.type })),
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'left',
        gap: 1.5,
        flexWrap: { xs: 'wrap', md: 'nowrap' },
        overflowX: { xs: 'visible', md: 'auto' },
        py: 1,
        '&::-webkit-scrollbar': { display: 'none' },
      }}>
      {options.map((option) => {
        const isSelected = option.value === '0' ? selected.length === 0 : selected.includes(option.value);
        return (
          <Box
            key={option.value}
            onClick={() => handleSelect(option.value)}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
              minWidth: 90,
              px: 0.5,
              py: 0.5,
              borderRadius: '8px',
              cursor: 'pointer',
              flexShrink: 0,
              backgroundColor: isSelected ? '#e8f5e2' : '#f8f8f8',
              border: isSelected ? '2px solid #0d7f42' : '1px solid #a4a4a4',
              transition: 'all 0.2s',
            }}>
            <Box
              sx={{
                width: isTabletOrMobile ? 18 : 26,
                height: isTabletOrMobile ? 18 : 26,
                borderRadius: '50%',
                backgroundColor: isSelected ? '#c5e8b0' : '#cfe5d9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              {option.value === '0' ? (
                <AppsIcon sx={{ color: isSelected ? '#0d7f42' : '#ffffff', fontSize: 16 }} />
              ) : (
                <Box
                  component="img"
                  src={iconMap[option.value]}
                  alt={option.label}
                  sx={{ width: isTabletOrMobile ? 18 : 26, height: isTabletOrMobile ? 18 : 26, objectFit: 'contain' }}
                />
              )}
            </Box>
            <Typography
              sx={{
                fontSize: isTabletOrMobile ? 12 : 16,
                fontWeight: isSelected ? 700 : 400,
                color: isSelected ? '#0d7f42' : '#a4a4a4',
                textAlign: 'center',
                // lineHeight: 1.3,
                whiteSpace: 'nowrap',
              }}>
              {option.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
